import React from 'react';
import "./styles.css";

export function TextField(props: any) {
    return (
        <div className="input-style mt-2 mb-2">
            <div className="float-left">
                <span>{props.label}</span>
            </div>
            {props.error && <div className="float-right error-color">
                {props.error}
            </div>}
            <input type={props.type}
                className={`input-text ${props.error ? "error-border" : null}`}
                value={props.value !== null ? props.value : ""}
                onChange={(e) => props.onChange(props.fieldName, e.target.value)}
                disabled={props.disabled ? props.disabled : false}
                placeholder={props.placeholder ? props.placeholder : ""}
            />
        </div>
    )
}